<script setup lang="ts">
import type { LicenseEntitlementBooleanKey } from '#layers/license/public';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAuth } from '#layers/access/stores/auth';
import { entitlementGateTitleKey, entitlementTitleKey, useLicenseEntitlementGate } from '#layers/license/public';

interface Props {
	entitlementKey: LicenseEntitlementBooleanKey;
}

const { entitlementKey } = defineProps<Props>();

const { isGated } = useLicenseEntitlementGate(() => entitlementKey);
const { isOrganizationAdmin } = storeToRefs(useAuth());

const { t } = useI18n();

const feature = computed(() => t(entitlementTitleKey(entitlementKey)));

const title = computed(() => t(entitlementGateTitleKey(entitlementKey), { feature: feature.value }));

const description = computed(() => (isOrganizationAdmin.value ? t('license.gate.contact_sales_notice') : t('license.gate.contact_admin_notice')));
</script>

<template>
	<DNotice
		v-if="isGated"
		color="primary"
		orientation="horizontal"
		icon="lucide:gem"
		:title
		:description
		:ui="{ icon: 'self-start' }"
	>
		<template v-if="isOrganizationAdmin" #actions>
			<LicenseContactSalesButton />
		</template>
	</DNotice>
</template>
